///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot = abcsetup.thoughtspot || {};
abcsetup.thoughtspot.common = abcsetup.thoughtspot.common || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot.common = {
    init: function() {
        // Init CKEditor
        $('textarea.editor').each(function() {
            CKEDITOR.create($(this)[0], CKEDITOR.config);
        });

        /* hack to validate WYSIWYG */
        $('#app_models_event_email_email_invite_email_template').attr('style', 'display:block; position:absolute; height: 0; visibility:hidden;');

        $('#app_models_event_registration_details_registration_details_event_parent_id').on('change keyup', function(e) {
            const thoughtSpotEvent = $('#app_models_event_registration_details_registration_details_event_parent_id').find(':selected').val();

            if (thoughtSpotEvent) {
                abcsetup.blockUI(true);

                axios.get('/api/thoughtspot_event/'+thoughtSpotEvent+'/list')
                .then(response => {
                    let tsevent = response.data.event;

                    if (tsevent) {
                        $('#app_models_event_registration_details_registration_details_registration_start').val(moment(tsevent.registration_start, 'YYYY-MM-DD').format('YYYY-MM-DD'));
                        $('#app_models_event_registration_details_registration_details_registration_end').val(moment(tsevent.registration_end, 'YYYY-MM-DD').format('YYYY-MM-DD'));
                        $('#app_models_event_registration_details_registration_details_registration_drop_dead_date').val(moment(tsevent.registration_drop_dead_date, 'YYYY-MM-DD').format('YYYY-MM-DD'));
                        $('#app_models_event_registration_details_registration_details_attendee_deadline').val(moment(tsevent.attendee_deadline, 'YYYY-MM-DD').format('YYYY-MM-DD'));
                        $('#app_models_event_registration_details_registration_details_sponsorship_deadline').val(moment(tsevent.sponsorship_deadline, 'YYYY-MM-DD').format('YYYY-MM-DD'));
                        $('#app_models_event_registration_details_registration_details_exhibitor_cancellation_deadline').val(moment(tsevent.exhibitor_cancellation_deadline, 'YYYY-MM-DD').format('YYYY-MM-DD'));
                    }

                    abcsetup.unblockUI();
                })
                .catch(error => {
                    abcsetup.unblockUI();
                });
            } else {
                $('#app_models_event_registration_details_registration_details_registration_start').val(null);
                $('#app_models_event_registration_details_registration_details_registration_end').val(null);
                $('#app_models_event_registration_details_registration_details_registration_drop_dead_date').val(null);
                $('#app_models_event_registration_details_registration_details_attendee_deadline').val(null);
                $('#app_models_event_registration_details_registration_details_sponsorship_deadline').val(null);
                $('#app_models_event_registration_details_registration_details_exhibitor_cancellation_deadline').val(null);
            }
        });

        $('#update-button').on('click', function(e) {
            if ($('#thoughtspot_registration_event_list').find(':selected').val() === 'clear') {
                e.preventDefault()
                alert('You must select a ThoughtSpot Registration Event');
                return;
            }
        })

        // Show document upload fields by default
        $('.sponsorship_document_upload').attr('hidden', false);
        $('.faq_document_upload').attr('hidden', false);

        $(".delete_sponsorship_document").click(function() {
            var id = $(this).data("id");
            $.ajax(
                {
                    type: "DELETE",
                    url: "/api/thoughtspot/registrations/" + id + "/delete_sponsorship_document",
                    cache: false,
                    dataType: 'json',
                    data: {
                        "id": id,
                    },

                    success: function () {
                        abcsetup.alerts.show('Document Deleted', 'The document was deleted successfully.');
                        $('.sponsorship_document_upload').attr('hidden', true);
                    }
                });
        });

        $(".delete_faq_document").click(function() {
            var id = $(this).data("id");
            $.ajax(
                {
                    type: "DELETE",
                    url: "/api/thoughtspot/registrations/" + id + "/delete_faq_document",
                    cache: false,
                    dataType: 'json',
                    data: {
                        "id": id,
                    },

                    success: function () {
                        abcsetup.alerts.show('Document Deleted', 'The document was deleted successfully.');
                        $('.faq_document_upload').attr('hidden', true);
                    }
                });
        });

        //thoughtspot registration dates
        $('#app_models_event_event_info_event_info_registration_start').on('change', function(e) {
            let selectors = [
                '#app_models_event_event_info_event_info_registration_end',
                '#app_models_event_event_info_event_info_registration_drop_dead_date',
                '#app_models_event_event_info_event_info_attendee_deadline',
                '#app_models_event_event_info_event_info_sponsorship_deadline',
                '#app_models_event_event_info_event_info_exhibitor_cancellation_deadline'
            ];

            let min = moment($(this).val()).add(1, 'd').format('YYYY-MM-DD');

            for (const selector in selectors) {
                let field = $(selectors[selector]);

                if (field.val() < min) {
                    field.val("");
                }

                field.attr('min', min);
            }
        });

        //abe open close
        $('#app_models_event_event_info_event_info_open_date').on('change', function(e) {
            $('#app_models_event_event_info_event_info_close_date').attr('min', moment($(this).val()).add(1, 'd').format('YYYY-MM-DD'));
        });

        $('#app_models_event_event_info_event_info_close_date').on('change', function(e) {
            $('#app_models_event_event_info_event_info_open_date').attr('max', moment($(this).val()).subtract(1, 'd').format('YYYY-MM-DD'));
        });

        //abe buy period
        $('#app_models_event_event_info_event_info_buy_period_from').on('change', function(e) {
            $('#app_models_event_event_info_event_info_buy_period_to').attr('min', moment($(this).val()).add(1, 'd').format('YYYY-MM-DD'));
        });

        $('#app_models_event_event_info_event_info_buy_period_to').on('change', function(e) {
            $('#app_models_event_event_info_event_info_buy_period_from').attr('max', moment($(this).val()).subtract(1, 'd').format('YYYY-MM-DD'));
        });

        //abe ship period
        $('#app_models_event_event_info_event_info_ship_period_from').on('change', function(e) {
            $('#app_models_event_event_info_event_info_ship_period_to').attr('min', moment($(this).val()).add(1, 'd').format('YYYY-MM-DD'));
        });

        $('#app_models_event_event_info_event_info_ship_period_to').on('change', function(e) {
            $('#app_models_event_event_info_event_info_ship_period_from').attr('max', moment($(this).val()).subtract(1, 'd').format('YYYY-MM-DD'));
        });

        //abe deal period
        $('#app_models_event_event_info_event_info_dealperiod_from').on('change', function(e) {
            $('#app_models_event_event_info_event_info_dealperiod_to').attr('min', moment($(this).val()).add(1, 'd').format('YYYY-MM-DD'));
        });

        $('#app_models_event_event_info_event_info_dealperiod_to').on('change', function(e) {
            $('#app_models_event_event_info_event_info_dealperiod_from').attr('max', moment($(this).val()).subtract(1, 'd').format('YYYY-MM-DD'));
        });
    },

    /**
     * fieldError callback from _jquery.fieldValidate
     */
    fieldError: function() {
        var errorField = $('form').find('.invalid').first();
        console.log(errorField.parent().html());
        abcsetup.unblockUI();
    },
}
